import { Clock, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router';
import { LegalLink } from '../../reservations/public/PublicFrame';
import { usePortalOrganization } from '../api';
import { PhoneFrame } from '../frame/PhoneFrame';
import styles from '../frame/Phone.module.css';
import type { PortalMagicView } from '../types';
import local from './Activation.module.css';

/** Mandantenportal 02 „Einstieg · das Versprechen" — before the self-disclosure (M4 form = 03–07). */
export function IntroScreen({ view }: { view: PortalMagicView }) {
  const organization = usePortalOrganization(view.organization.slug);
  const privacyUrl = organization.data?.legal.privacyUrl ?? null;
  const advisorName = view.advisor?.name ?? 'Ihr Berater';
  return (
    <PhoneFrame tone="navy" title="Selbstauskunft">
      <div className={local.introBrand}>
        <div className={styles.brand}>DAMOKLES</div>
      </div>
      <div className={local.introHero}>
        <div className={styles.eyebrow}>Selbstauskunft · rund 8 Minuten</div>
        <h1 className={local.introTitle}>
          Füllen Sie die Fragen aus und erfahren Sie Ihr Finanzierungsvolumen.
        </h1>
        <p className={local.introText}>
          Im Anschluss sehen Sie in Ihrem Portal, wie viele Bestandswohnungen in Ihrem Rahmen liegen. Welche
          davon in Frage kommt, besprechen wir im Beratungstermin.
        </p>
      </div>
      <div className={`${styles.glass} ${local.introPoints}`}>
        <div className={local.point}>
          <ShieldCheck size={18} strokeWidth={1.5} aria-hidden="true" className={local.pointIcon} />
          <span>Ihre Angaben sieht ausschließlich Ihr Betreuer {advisorName}.</span>
        </div>
        <div className={local.point}>
          <Clock size={18} strokeWidth={1.5} aria-hidden="true" className={local.pointIcon} />
          <span>Sie können jederzeit unterbrechen. Eingaben bleiben gespeichert.</span>
        </div>
      </div>
      <div className={`${styles.footer} ${local.navyFooter}`}>
        {view.selfDisclosureToken ? (
          <Link
            to={`/sd/${encodeURIComponent(view.selfDisclosureToken)}`}
            className={`pressable ${styles.primary} ${local.bigPrimary}`}
          >
            Jetzt starten
          </Link>
        ) : null}
        {privacyUrl ? (
          <LegalLink
            url={privacyUrl}
            title="Erstinformation und Datenschutzhinweise"
            className={local.introLegal}
          />
        ) : null}
      </div>
    </PhoneFrame>
  );
}
